var _a;
import { getApiBaseUrl, getAuthBaseUrl, } from '@cardlesshq/constants';
import { ApiClient } from '@cardlesshq/web-api-client/src/apiClient';
import { AuthClient } from '@cardlesshq/web-api-client/src/authClient';
import SimpleCrypto from 'simple-crypto-js';
import { SDKClient } from './sdk';
const env = ((_a = process.env.CONFIG_ENV) !== null && _a !== void 0 ? _a : 'staging');
const cipher = new SimpleCrypto(process.env.CONF_PUBLIC_CIPHER_KEY);
const basicAuth = cipher.decrypt(process.env.CONF_API_BASIC_AUTH_CIPHERTEXT);
const [username, password] = basicAuth.split(':');
const authClient = new AuthClient({
    baseUrl: getAuthBaseUrl(env),
    auth: {
        username,
        password,
    },
});
const apiClient = new ApiClient({
    baseUrl: getApiBaseUrl(env),
});
const client = new SDKClient({
    authClient,
    apiClient,
});
client.acceptSDKData();
// so we can test static methods
window.client = client;
export { client };
